import { render, staticRenderFns } from "./SupportMaterialModal.vue?vue&type=template&id=0872d78c&scoped=true&"
import script from "./SupportMaterialModal.vue?vue&type=script&lang=js&"
export * from "./SupportMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportMaterialModal.vue?vue&type=style&index=0&id=0872d78c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872d78c",
  null
  
)

component.options.__file = "SupportMaterialModal.vue"
export default component.exports